import { Box, Spacer, TextNew } from '@jfs/ui-new'
import { FC } from 'react'
import { paymentDetailsStrings } from '../../data/static/strings'
import { useWindowDimensions } from '../../util/util'
import { styles } from './styles'

export interface ConvenienceFeeDetailsObj {
  amount: string
  ugst: string
  sgst: string
  igst: string
  cgst: string
  originalTxnAmt: string
}
interface ConvenienceFeeDetailsProps {
  convenienceFeeDetails: ConvenienceFeeDetailsObj
}

const ConvenienceFeeDetails: FC<ConvenienceFeeDetailsProps> = ({
  convenienceFeeDetails,
}: ConvenienceFeeDetailsProps) => {
  const viewPortWidth = useWindowDimensions()
  const themes = styles(viewPortWidth)
  return (
    <Box {...themes.detailsContainer}>
      <TextNew type={'body16'} fontWeight="bold">
        {paymentDetailsStrings.labelConvenienceFee}
      </TextNew>
      <Spacer size={16} />
      <Box {...themes.detailsMainContainer}>
        <Box {...themes.detailsContent}>
          <Box {...themes.detailsSubContainer}>
            <TextNew type={'body12'} fontWeight="bold">
              {paymentDetailsStrings.labelConvenienceAmount}
            </TextNew>
            <Spacer size={8} />
            <TextNew type={'body12'} fontWeight="bold">
              {paymentDetailsStrings.labelOriginalTxnAmount}
            </TextNew>
            <Spacer size={8} />
            <TextNew type={'body12'} fontWeight="bold">
              {paymentDetailsStrings.labelCGST}
            </TextNew>
          </Box>
          <Box {...themes.detailsSubContainer}>
            <TextNew type={'body12'}>{convenienceFeeDetails?.amount}</TextNew>
            <Spacer size={8} />
            <TextNew type={'body12'}>{convenienceFeeDetails?.originalTxnAmt}</TextNew>
            <Spacer size={8} />
            <TextNew type={'body12'}>{convenienceFeeDetails?.cgst}</TextNew>
          </Box>
        </Box>
        <Box {...themes.divider} />
        <Box {...themes.detailsSideContainer}>
          <Box {...themes.detailsSubContainer}>
            <TextNew type={'body12'} fontWeight="BOLD">
              {paymentDetailsStrings?.labelSGST ?? ''}
            </TextNew>
            <Spacer size={8} />
            <TextNew type={'body12'} fontWeight="bold">
              {paymentDetailsStrings?.labelIGST ?? ''}
            </TextNew>
            <Spacer size={8} />
            <TextNew type={'body12'} fontWeight="bold">
              {paymentDetailsStrings?.labelUGST ?? ''}
            </TextNew>
          </Box>
          <Box {...themes.detailsSubContainer}>
            <TextNew type={'body12'}>{convenienceFeeDetails?.sgst}</TextNew>
            <Spacer size={8} />
            <TextNew type={'body12'}>{convenienceFeeDetails?.igst}</TextNew>
            <Spacer size={8} />
            <TextNew type={'body12'}>{convenienceFeeDetails?.ugst}</TextNew>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default ConvenienceFeeDetails
